export const CustomDomainCandidateFormPagePath = '/flows/:formSlug';
export const CandidateFormPagePath = '/:companySlug/:formSlug';
